import { styled } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    background: "#FFF",
    borderRadius: "4px",
    color: "var(--color-text-primary)",
    fontSize: "14px",
    padding: "8px",
    boxShadow: "0 2px 16px 0 rgba(0, 0, 0, 0.24)",
    fontWeight: 400,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#FFF",
  },
}));

export default function Popover({ children, tooltipOpen, content }) {
  return (
    <StyledTooltip
      title={content}
      arrow
      open={tooltipOpen}
      slotProps={{
        popper: {
          sx: {
            [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
              {
                marginTop: "5px",
              },
          },
        },
      }}
    >
      {children}
    </StyledTooltip>
  );
}
